var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxLinearProfile2User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.568,
    height: 16.568,
    viewBox: "0 0 16.568 16.568",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_profile-2user",
    "data-name": "vuesax/linear/profile-2user",
    transform: "translate(-172 -252)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-2user",
    transform: "translate(172 252)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.176,6.123a1.255,1.255,0,0,0-.228,0,3.069,3.069,0,1,1,.228,0Z",
    transform: "translate(3.148 1.381)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.09,0A2.414,2.414,0,0,1,2.506,2.416,2.42,2.42,0,0,1,.179,4.832a.78.78,0,0,0-.179,0",
    transform: "translate(11.239 2.761)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M1.253.948A2.265,2.265,0,0,0,1.253,5a6.742,6.742,0,0,0,6.91,0,2.265,2.265,0,0,0,0-4.052A6.774,6.774,0,0,0,1.253.948Z",
    transform: "translate(1.619 9.104)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,4.142a3.339,3.339,0,0,0,1.353-.6,1.749,1.749,0,0,0,0-2.948A3.433,3.433,0,0,0,.021,0",
    transform: "translate(12.661 9.665)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H16.568V16.568H0Z",
    transform: "translate(16.568 16.568) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxLinearProfile2User);
export default __webpack_public_path__ + "static/media/vuesax-linear-profile-2user.70fdb5952081ab12c6f49d7875b53871.svg";
export { ForwardRef as ReactComponent };